import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect
} from 'react-router-dom';
import Account from '../components/Account';
import Dashboard from '../components/Dashboard';
import ForgotPassword from '../components/ForgotPassword';
import Header from '../components/Header';
import Login from '../components/Login';
import Logout from '../components/Logout';
import NotFound from '../components/NotFound';
import PasswordRecovery from '../components/PasswordRecovery';
import Files from '../components/Files';
import FilesImport from '../components/FilesImport';
import FilesImportMap from '../components/FilesImportMap';
import Egfr from '../components/Egfr';
import EgfrCalculate from '../components/EgfrCalculate';
import Users from '../components/Users';
import UsersNew from '../components/UsersNew';
import UsersUpdate from '../components/UsersUpdate';
import Api from '../config/Api';

class AppRouter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: '',
			isLogged: false,
			permissions: ''
		}
	}

	componentWillMount() {
		var self = this;
		if(localStorage.logged || sessionStorage.logged) {
			this.setState({
				token: (localStorage.token ? localStorage.token : sessionStorage.token),
				isLogged: true
			}, function() {
				Api.parseToken(this.state.token, function(response) {
					self.setState({
						permissions: response.permissions
					});
				});
			});
		}
	}

    render() {
    	if(this.state.isLogged) {
    		return(
	        	<Router>
		            <div>
		                <Header isLogged={this.state.isLogged} />
		                <main>
		                	<Switch>
			    				<Route exact path="/account" component={Account}></Route>
				    			<Route exact path="/dashboard" component={Dashboard}></Route>
				    			<Route exact path="/logout" component={Logout}></Route>
				    			<Route exact path="/files" component={Files}></Route>
				    			<Route exact path="/files/import/map/:id" component={FilesImportMap}></Route>
				    			<Route exact path="/files/import" component={FilesImport}></Route>
				    			<Route exact path="/egfr" component={Egfr}></Route>
				    			<Route exact path="/egfr/calculate/:id" component={EgfrCalculate}></Route>
				    			{this.state.permissions === 'admin' ?
					    			<Route exact path="/users/new" component={UsersNew}></Route>
					    		: null}
					    		{this.state.permissions === 'admin' ?
					    			<Route exact path="/users/:id" component={UsersUpdate}></Route>
					    		: null}
					    		{this.state.permissions === 'admin' ?
					    			<Route exact path="/users" component={Users}></Route>
					    		: null}
				    			<Redirect exact from="/" to="/dashboard" />
				    			<Route path="*" component={NotFound} status={404}></Route>
			    			</Switch>
		                </main>
		            </div>
		        </Router>
	        );
    	} else {
    		return(
	        	<Router>
		            <div>
		                <Header isLogged={this.state.isLogged} />
		                <main>
		                	<Switch>
				    			<Route exact path="/forgotpassword" component={ForgotPassword}></Route>
				    			<Route exact path="/login" component={Login}></Route>
				    			<Route exact path="/passwordrecovery/:code" component={PasswordRecovery}></Route>
				    			<Redirect exact from="/" to="/login" />
				    			<Route path="*" component={NotFound} status={404}></Route>
			    			</Switch>
		                </main>
		            </div>
		        </Router>
	        );
    	}
    }
}

export default AppRouter;


// WEBPACK FOOTER //
// ./src/config/AppRouter.js